import { CloseOutlined } from '@ant-design/icons'
import styles from './view-case-graph.module.scss'

interface GraphDialogHeaderProps {
  entityName: string
  onClose: () => void
}

export function GraphDialogHeader({ entityName, onClose }: GraphDialogHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <span className={styles.title}>{entityName} Network</span>
      </div>
      <button className={styles.closeButton} onClick={onClose} aria-label='Close network graph'>
        <CloseOutlined />
      </button>
    </div>
  )
}
